<template>
    <div>
        <LiefengContent>
            <template v-slot:title>组件评论管理</template>
            <template v-slot:toolsbarLeft>
                <Button type="primary" icon="ios-add" @click="handleAdd">新增</Button>
            </template>
            <template v-slot:toolsbarRight>
                <Form :label-colon="true" :inline="true" class="search">
                    <FormItem label="标题" :label-width="50">
                        <Input v-model.trim="searchData.name" placeholder="请输入标题" style="width: 160px" clearable></Input>
                    </FormItem>
                    <Button type="primary" icon="ios-search" @click="getList">查询</Button>
                    <Button type="info" icon="md-refresh" @click="reset" style="margin-left: 10px">重置</Button>
                </Form>
            </template>
            <template v-slot:contentArea>
                <LiefengTable
                    :talbeColumns="talbeColumns"
                    :tableData="tableData"
                    :loading="loading"
                    :fixTable="true"
                    :curPage="page"
                    :total="total"
                    :pagesizeOpts="[10, 20, 30, 50]"
                    :page-size="pageSize"
                    @hadlePageSize="hadlePageSize"
                    @tableSelect="tableSelect"
                ></LiefengTable>
            </template>
        </LiefengContent>

        <!-- 新增/修改弹窗 -->
        <LiefengModal 
            :title="modalTitle" 
            :value="modalVisible" 
            @input="handleModalClose" 
            width="700px"
        >
            <template v-slot:contentarea>
                <Form ref="formData" :model="formData" :rules="formRules" :label-width="120">
                    <FormItem label="标题" prop="name">
                        <span slot="label" class="validate">标题:</span>
                        <Input v-model.trim="formData.name" placeholder="请输入标题" style="width: 400px"></Input>
                    </FormItem>
                    <FormItem label="机构" prop="orgCodeSelf">
                        <span slot="label" class="validate">机构:</span>
                        <!-- 显示模式：修改时显示orgName -->
                        <div v-if="modalType === 'edit' && !showOrgSelect" style="display: flex; align-items: center;">
                            <Input 
                                :value="formData.orgName" 
                                placeholder="未选择机构" 
                                readonly 
                                style="width: 320px"
                            ></Input>
                            <Button type="primary" @click="handleShowOrgSelect" style="margin-left: 10px">
                                修改机构
                            </Button>
                        </div>
                        <!-- 编辑模式：新增或点击修改后显示Select -->
                        <div v-else style="display: flex; align-items: center;">
                            <Select 
                                v-model="formData.orgCodeSelf" 
                                placeholder="请输入机构名称或编码搜索" 
                                filterable 
                                remote 
                                :remote-method="remoteFormOrg"
                                :loading="formOrgLoading"
                                @on-change="handleOrgChange"
                                style="width: 320px"
                                clearable
                            >
                                <Option :value="item.orgCode" v-for="item in formOrgList" :key="item.orgCode">
                                    {{item.orgName}} ({{item.orgCode}})
                                </Option>
                            </Select>
                            <Button v-if="modalType === 'edit'" @click="cancelOrgSelect" style="margin-left: 10px">取消</Button>
                        </div>
                    </FormItem>
                    <FormItem label="背景图">
                        <span slot="label">背景图:</span>
                        <LiefengUpload 
                            ref="bgImgUpload" 
                            v-if="showBgImg"
                            type="image"
                            accept=".jpg,.png,.gif,.jpeg" 
                            :format="['jpg', 'png', 'jpeg', 'gif']" 
                            :defaultList="bgImgList" 
                            :showView="true"
                            :fileLength="1"
                        ></LiefengUpload>
                    </FormItem>
                    <FormItem label="按钮图片">
                        <span slot="label">按钮图片:</span>
                        <LiefengUpload 
                            ref="buttonImgUpload" 
                            v-if="showButtonImg"
                            type="image"
                            accept=".jpg,.png,.gif,.jpeg" 
                            :format="['jpg', 'png', 'jpeg', 'gif']" 
                            :defaultList="buttonImgList" 
                            :showView="true"
                            :fileLength="1"
                        ></LiefengUpload>
                    </FormItem>
                    <FormItem label="按钮名称">
                        <span slot="label">按钮名称:</span>
                        <Input v-model.trim="formData.buttonName" placeholder="请输入按钮名称" style="width: 400px"></Input>
                    </FormItem>
                </Form>
            </template>
            <template v-slot:toolsbar>
                <Button type="primary" @click="handleSave" :loading="saveLoading">保存</Button>
                <Button type="info" @click="handleModalClose(false)" style="margin-left: 10px">取消</Button>
            </template>
        </LiefengModal>

    </div>
</template>

<script>
import LiefengContent from "@/components/LiefengContent3"
import LiefengTable from "@/components/LiefengTable"
import LiefengModal from "@/components/LiefengModal"
import LiefengUpload from "@/components/LiefengUpload"

export default {
    components: { 
        LiefengContent, 
        LiefengTable, 
        LiefengModal, 
        LiefengUpload
    },
    data() {
        return {
            searchData: {
                name: "",
                orgCodeSelf: ""
            },
            searchOrgList: [],
            searchOrgLoading: false,
            tableData: [],
            loading: false,
            page: 1,
            pageSize: 10,
            total: 0,
            
            
            modalVisible: false,
            modalTitle: "新增",
            modalType: "add",
            saveLoading: false,
            
            showBgImg: true,
            showButtonImg: true,
            
            formData: {
                id: null,
                name: "",
                orgCodeSelf: "",
                orgName: "",
                bgImg: "",
                buttonImg: "",
                buttonName: ""
            },
            formOrgList: [],
            formOrgLoading: false,
            dimensionList: [],
            showOrgSelect: false,
            tempOrgCodeSelf: "",
            tempOrgName: "",
            
            bgImgList: [],
            buttonImgList: [],
            
            formRules: {
                name: [
                    { required: true, message: "标题不能为空", trigger: "blur" }
                ],
                orgCodeSelf: [
                    { required: true, message: "机构不能为空", trigger: "change" }
                ]
            },
            
            talbeColumns: [
                {
                    title: "ID",
                    key: "id",
                    minWidth: 200,
                    align: "center"
                },
                {
                    title: "标题",
                    key: "name",
                    minWidth: 200,
                    align: "center"
                },
                {
                    title: "机构名称",
                    key: "orgName",
                    minWidth: 200,
                    align: "center",
                    render: (h, params) => {
                        return h("span", params.row.orgName || params.row.orgCodeSelf || "-")
                    }
                },
                {
                    title: "背景图",
                    minWidth: 120,
                    align: "center",
                    render: (h, params) => {
                        if (params.row.bgImg) {
                            return h("img", {
                                attrs: {
                                    src: params.row.bgImg
                                },
                                style: {
                                    width: "80px",
                                    height: "60px",
                                    objectFit: "cover",
                                    cursor: "pointer"
                                },
                                on: {
                                    click: () => {
                                        window.open(params.row.bgImg)
                                    }
                                }
                            })
                        }
                        return h("span", "-")
                    }
                },
                {
                    title: "按钮图片",
                    minWidth: 120,
                    align: "center",
                    render: (h, params) => {
                        if (params.row.buttonImg) {
                            return h("img", {
                                attrs: {
                                    src: params.row.buttonImg
                                },
                                style: {
                                    width: "80px",
                                    height: "60px",
                                    objectFit: "cover",
                                    cursor: "pointer"
                                },
                                on: {
                                    click: () => {
                                        window.open(params.row.buttonImg)
                                    }
                                }
                            })
                        }
                        return h("span", "-")
                    }
                },
                {
                    title: "按钮名称",
                    key: "buttonName",
                    minWidth: 120,
                    align: "center"
                },
                {
                    title: "创建时间",
                    minWidth: 180,
                    align: "center",
                    render: (h, params) => {
                        return h("span", params.row.gmtCreate || "-")
                    }
                },
                {
                    title: "修改时间",
                    minWidth: 180,
                    align: "center",
                    render: (h, params) => {
                        return h("span", params.row.gmtModified || "-")
                    }
                },
                {
                    title: "操作",
                    minWidth: 240,
                    align: "center",
                    fixed: "right",
                    render: (h, params) => {
                        return h("div", [
                            h("Button", {
                                props: {
                                    type: "primary",
                                    size: "small"
                                },
                                style: {
                                    marginRight: "5px"
                                },
                                on: {
                                    click: () => {
                                        this.handleEdit(params.row)
                                    }
                                }
                            }, "修改"),
                            h("Button", {
                                props: {
                                    type: "primary",
                                    size: "small"
                                },
                                style: {
                                    marginRight: "5px"
                                },
                                on: {
                                    click: () => {
                                        this.handleContentManage(params.row)
                                    }
                                }
                            }, "内容管理"),
                            h("Button", {
                                props: {
                                    type: "error",
                                    size: "small"
                                },
                                on: {
                                    click: () => {
                                        this.handleDelete(params.row)
                                    }
                                }
                            }, "删除")
                        ])
                    }
                }
            ]
        }
    },
    created() {
        this.getDimensionList()
        this.getList()
    },
    methods: {
        getList() {
            this.loading = true
            this.$get(`/gateway/syinfopublish/api/pc/compComment/selectCompCommentPage?page=${this.page}&pageSize=${this.pageSize}&name=${this.searchData.name}&orgCodeSelf=${this.searchData.orgCodeSelf}`).then(res => {
                this.loading = false
                if (res.code == "200") {
                    this.tableData = res.dataList || []
                    this.total = res.maxCount || 0
                } else {
                    this.$Message.error({
                        content: res.msg || res.desc || "查询失败",
                        background: true
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        
        getDimensionList() {
            this.$get('/gx/pc/dimension/selectExceptOneByOemCode', {
                oemCode: parent.vue.oemInfo.oemCode
            }).then(res => {
                if (res.code == 200 && res.dataList) {
                    this.dimensionList = res.dataList
                }
            })
        },
        
        remoteSearchOrg(query) {
            if (query !== '') {
                this.searchOrgLoading = true
                this.$get('/datamsg/api/pc/platformMenu/queryOrgPageByDimensionId', {
                    dimensionId: this.searchData.dimensionId || '',
                    nameOrCode: query,
                    oemCode: parent.vue.oemInfo.oemCode,
                    page: 1,
                    pageSize: 50,
                    scopeCodes: '',
                    scopeType: '',
                    platformMenuId: ''
                }).then(res => {
                    this.searchOrgLoading = false
                    if (res.code == 200 && res.dataList) {
                        this.searchOrgList = res.dataList
                    } else {
                        this.searchOrgList = []
                    }
                }).catch(() => {
                    this.searchOrgLoading = false
                    this.searchOrgList = []
                })
            } else {
                this.searchOrgList = []
            }
        },
        
        remoteFormOrg(query) {
            if (query !== '') {
                this.formOrgLoading = true
                this.$get('/datamsg/api/pc/platformMenu/queryOrgPageByDimensionId', {
                    dimensionId: '',
                    nameOrCode: query,
                    oemCode: parent.vue.oemInfo.oemCode,
                    page: 1,
                    pageSize: 50,
                    scopeCodes: '',
                    scopeType: '',
                    platformMenuId: ''
                }).then(res => {
                    this.formOrgLoading = false
                    if (res.code == 200 && res.dataList) {
                        this.formOrgList = res.dataList
                    } else {
                        this.formOrgList = []
                    }
                }).catch(() => {
                    this.formOrgLoading = false
                    this.formOrgList = []
                })
            } else {
                this.formOrgList = []
            }
        },
        
        handleShowOrgSelect() {
            this.tempOrgCodeSelf = this.formData.orgCodeSelf
            this.tempOrgName = this.formData.orgName
            this.showOrgSelect = true
        },
        
        handleOrgChange(orgCode) {
            if (!orgCode) {
                this.formData.orgName = ""
                return
            }
            const selectedOrg = this.formOrgList.find(item => item.orgCode === orgCode)
            if (selectedOrg) {
                this.formData.orgName = selectedOrg.orgName
                this.showOrgSelect = false
                this.formOrgList = []
            }
        },
        
        cancelOrgSelect() {
            this.formData.orgCodeSelf = this.tempOrgCodeSelf
            this.formData.orgName = this.tempOrgName
            this.showOrgSelect = false
            this.formOrgList = []
        },
        
        reset() {
            this.searchData = {
                name: "",
                orgCodeSelf: ""
            }
            this.searchOrgList = []
            this.page = 1
            this.getList()
        },
        
        hadlePageSize(page, pageSize) {
            this.page = page
            this.pageSize = pageSize
            this.getList()
        },
        
        tableSelect(selection, row) {
        },
        
        handleAdd() {
            this.modalType = "add"
            this.modalTitle = "新增"
            this.formData = {
                id: null,
                name: "",
                orgCodeSelf: "",
                orgName: "",
                bgImg: "",
                buttonImg: "",
                buttonName: ""
            }
            this.formOrgList = []
            this.showOrgSelect = false
            this.bgImgList = []
            this.buttonImgList = []
            this.showBgImg = false
            this.showButtonImg = false
            this.$nextTick(() => {
                this.showBgImg = true
                this.showButtonImg = true
                this.$refs.formData?.resetFields()
            })
            this.modalVisible = true
        },
        
        handleEdit(row) {
            this.modalType = "edit"
            this.modalTitle = "修改"
            
            this.formData = {
                id: row.id,
                name: row.name,
                orgCodeSelf: row.orgCodeSelf,
                orgName: row.orgName || "",
                bgImg: row.bgImg || "",
                buttonImg: row.buttonImg || "",
                buttonName: row.buttonName || ""
            }
            
            this.showOrgSelect = false
            
            this.bgImgList = row.bgImg ? [{ name: "", url: row.bgImg }] : []
            this.buttonImgList = row.buttonImg ? [{ name: "", url: row.buttonImg }] : []
            
            this.showBgImg = false
            this.showButtonImg = false
            this.$nextTick(() => {
                this.showBgImg = true
                this.showButtonImg = true
            })
            
            this.modalVisible = true
        },
        
        handleContentManage(row) {
            const query = {
                type: row.id  // id作为infoType
            }
            // 只有当orgCodeSelf存在时才传递
            if (row.orgCodeSelf) {
                query.orgCodeSelf = row.orgCodeSelf
            }
            this.$router.push({
                path: "/orgcomment",
                query: query
            })
        },
        
        handleDelete(row) {
            this.$Modal.confirm({
                title: "提示",
                content: "确定要删除该记录吗？",
                onOk: () => {
                    this.$post("/gateway/syinfopublish/api/pc/compComment/deleteCompComment", null, {
                        params: {
                            id: row.id
                        }
                    }).then(res => {
                        if (res.code == "200") {
                            this.$Message.success({
                                content: "删除成功",
                                background: true
                            })
                            this.getList()
                        } else {
                            this.$Message.error({
                                content: res.msg || "删除失败",
                                background: true
                            })
                        }
                    })
                }
            })
        },
        
        handleSave() {
            this.$refs.formData.validate(valid => {
                if (valid) {
                    const bgImgUploadList = this.$refs.bgImgUpload?.uploadList || []
                    const buttonImgUploadList = this.$refs.buttonImgUpload?.uploadList || []
                    
                    const params = {
                        name: this.formData.name,
                        orgCodeSelf: this.formData.orgCodeSelf,
                        orgName: this.formData.orgName,
                        bgImg: bgImgUploadList.length > 0 ? bgImgUploadList[0].url : "",
                        buttonImg: buttonImgUploadList.length > 0 ? buttonImgUploadList[0].url : "",
                        buttonName: this.formData.buttonName
                    }
                    
                    if (this.modalType === "edit") {
                        params.id = this.formData.id
                    }
                    
                    if (!params.orgCodeSelf) {
                        this.$Message.error({
                            content: "机构代码不能为空",
                            background: true
                        })
                        return
                    }
                    
                    this.saveLoading = true
                    const apiUrl = this.modalType === "add" 
                        ? "/gateway/syinfopublish/api/pc/compComment/addCompComment" 
                        : "/gateway/syinfopublish/api/pc/compComment/updateCompComment"
                    
                    this.$post(apiUrl, params, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }).then(res => {
                        this.saveLoading = false
                        if (res.code == "200") {
                            this.$Message.success({
                                content: this.modalType === "add" ? "新增成功" : "修改成功",
                                background: true
                            })
                            this.handleModalClose(false)
                            this.getList()
                        } else {
                            this.$Message.error({
                                content: res.msg || "保存失败",
                                background: true
                            })
                        }
                    }).catch(() => {
                        this.saveLoading = false
                    })
                }
            })
        },
        
        handleModalClose(status) {
            this.modalVisible = status
            if (!status) {
                this.$refs.formData?.resetFields()
            }
        }
    }
}
</script>

<style lang="less" scoped>
/deep/.validate {
    &::before {
        content: "*";
        display: inline-block;
        margin-right: 4px;
        line-height: 1;
        font-family: SimSun;
        font-size: 14px;
        color: #ed4014;
    }
}
</style>
